import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, FileText, AlertTriangle, UserX, Server } from 'lucide-react';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        {/* Back button */}
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
          data-testid="terms-back-btn"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm p-8 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <FileText className="h-6 w-6 text-purple-600" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900">Terms & Conditions</h1>
          </div>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mb-6"></div>
          
          <p className="text-lg text-gray-700 leading-relaxed">
            By using POLIVOX, you agree to follow the platform rules.
          </p>
        </div>

        {/* Content Sections */}
        <div className="space-y-6">
          {/* User Responsibility */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <AlertTriangle className="h-5 w-5 text-amber-600" />
              <h2 className="text-xl font-semibold text-gray-900">User Responsibilities</h2>
            </div>
            <p className="text-gray-600 leading-relaxed mb-4">
              Users are responsible for the content they post. You agree not to:
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>Post harmful, abusive, or illegal content</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>Spread misinformation or hate speech</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>Impersonate others</span>
              </li>
            </ul>
          </div>

          {/* Platform Rights */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <UserX className="h-5 w-5 text-red-600" />
              <h2 className="text-xl font-semibold text-gray-900">Platform Rights</h2>
            </div>
            <p className="text-gray-600 leading-relaxed">
              POLIVOX reserves the right to remove content or suspend accounts that violate 
              these rules. We maintain the right to enforce community standards to ensure 
              a safe and constructive environment for all users.
            </p>
          </div>

          {/* Service Disclaimer */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <Server className="h-5 w-5 text-blue-600" />
              <h2 className="text-xl font-semibold text-gray-900">Service Disclaimer</h2>
            </div>
            <p className="text-gray-600 leading-relaxed">
              The platform is provided "as is" without guarantees of uninterrupted service. 
              We strive to maintain high availability but cannot guarantee 100% uptime.
            </p>
          </div>

          {/* Agreement */}
          <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl p-6 border border-purple-100">
            <p className="text-gray-700 text-center font-medium">
              By continuing to use POLIVOX, you accept these terms.
            </p>
          </div>
        </div>

        {/* Last updated */}
        <div className="text-center text-gray-400 text-sm mt-8">
          <p>Last updated: March 2026</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
